import { render } from "./Characters.vue?vue&type=template&id=d39194bc&scoped=true"
import script from "./Characters.vue?vue&type=script&lang=js"
export * from "./Characters.vue?vue&type=script&lang=js"

import "./Characters.vue?vue&type=style&index=0&id=d39194bc&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d39194bc"]])

export default __exports__